import React from "react";
import ReactDOM from "react-dom/client";
import "src/index.css";
import App from "src/App";
import reportWebVitals from "src/reportWebVitals";
import { store } from "src/store";
import { Provider } from "react-redux";
import { ZoomLevelProvider } from "src/context/ZoomLevelContext";

import "src/i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ZoomLevelProvider>
        <App />
      </ZoomLevelProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
